import { RadixCheckbox } from '../../../../components/ui/checkbox';
import { cn } from '../../../../lib/utils';

export interface CheckboxProps extends React.ComponentProps<
  typeof RadixCheckbox
> {
  /** 체크박스의 고유 식별자 */
  id?: string;
  /** 체크박스의 상태 */
  status?: 'default' | 'disabled';
  /** 체크박스의 라벨 */
  label?: string;
  /** 체크박스의 크기 */
  size?: 'small' | 'medium';
}

export default function Checkbox({
  id,
  label,
  checked,
  status = 'default',
  size = 'medium',
  ...props
}: CheckboxProps) {
  return (
    <div
      className={cn(
        'group flex cursor-pointer items-center gap-2xs',
        status === 'disabled' && 'cursor-not-allowed',
      )}
      aria-disabled={status === 'disabled'}
    >
      <RadixCheckbox
        id={id || ''}
        checked={checked}
        disabled={status === 'disabled'}
        className={cn(
          'checkbox border-2 border-comp-checkbox-border-default bg-comp-checkbox-bg-default',
          status === 'disabled' &&
            '[&>span>svg>g>path]:fill-comp-checkbox-icon-checked',
        )}
        style={{
          cursor: 'inherit',
        }}
        data-size={size}
        {...props}
      />
      {label && (
        <label
          htmlFor={id}
          className={cn(
            'group-aria-disabled:pointer-events-none group-aria-disabled:cursor-not-allowed',
            status === 'disabled' && 'text-sys-cont-neutral-disabled-lightest',
            size === 'medium' && 'text-comp-moderate-medium',
            size === 'small' && 'text-comp-moderate-small',
          )}
          style={{
            cursor: 'inherit',
          }}
        >
          <div
            className={cn(
              'text-comp-checkbox-text-default transition-all',
              status === 'disabled' && 'text-comp-checkbox-text-disabled',
            )}
          >
            {label}
          </div>
        </label>
      )}
    </div>
  );
}
